export const MODEL_COLOR = {
    blueApply:'#99d6edff', 
    blueUltraLight:'#bfbfff',
    lightGrey:'#f2f2f2ff',
    lightGreen:'#d5ffe6ff',
}

